function extractData(dataToken = '#DATA=', sourceString = '') {
    const start = sourceString.indexOf(dataToken);

    if (start === -1) return '';

    return sourceString.substring(start + dataToken.length).split(/[#//&]/)[0];
}

const urlDataExtractor = dataToken => extractData(dataToken, decodeURIComponent(dataToken));

if (location.hash && sessionStorage && sessionStorage.setItem) {
    sessionStorage.setItem('glipData', urlDataExtractor('#DATA=', location.hash));
}
